export const performance = [
  { value: 1, text: "Poor" },
  { value: 2, text: "Average" },
  { value: 3, text: "Good" },
  { value: 4, text: "Outstanding" },
];
export const talent = [
  { value: 1, text: "Limited" },
  { value: 2, text: "Moderate" },
  { value: 3, text: "High" },
];
export const development = [
  { value: 1, text: "Values" },
  { value: 2, text: "Skills" },
  { value: 3, text: "Leadership" },
];
export const jenisKelamin = [
  { value: 1, text: "Laki-Laki" },
  { value: 2, text: "Perempuan" },
];
